import React from "react";
import Popover from "components/common/Popover";
import OverflowingComponentsContextProvider from "views/components/contexts/OverflowingComponentsContextProvider";
const OnClickPopoverWrapper = ({ children = null, isPopoverOpen, onPopoverChange, style }, ref) => /* @__PURE__ */ React.createElement(OverflowingComponentsContextProvider, null, /* @__PURE__ */ React.createElement(
  Popover,
  {
    opened: isPopoverOpen,
    onChange: onPopoverChange,
    withArrow: true,
    withinPortal: false,
    position: "bottom",
    offset: 0
  },
  /* @__PURE__ */ React.createElement(Popover.Target, null, /* @__PURE__ */ React.createElement("div", { ref, style })),
  children
));
export default React.forwardRef(OnClickPopoverWrapper);
